/**
 * Версия протокола.
 *
 * Зачем она в рукопожатии. Overlay живёт в browser source OBS и может быть
 * открыт неделями без перезагрузки: стример добавил источник один раз и
 * забыл. За это время сервер обновится не раз. Клиент старой версии обязан
 * получить внятный отказ с причиной, а не молча получать сообщения, которые
 * он разбирает неправильно.
 *
 * Правило совместимости: major меняется, когда меняется форма уже
 * существующего сообщения или смысл поля; minor - когда добавляется новое
 * сообщение или необязательное поле. Сервер принимает клиента с тем же major
 * и любым minor: старый клиент просто не знает о новых сообщениях и
 * игнорирует их.
 */
export const PROTOCOL_VERSION = { major: 1, minor: 1 };
export const PROTOCOL_VERSION_STRING = `${PROTOCOL_VERSION.major}.${PROTOCOL_VERSION.minor}`;
export function isCompatible(client) {
    return client.major === PROTOCOL_VERSION.major;
}
//# sourceMappingURL=version.js.map